// src/redux/exhibitorProductSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk for fetching exhibitor product data
export const fetchExhibitorProducts = createAsyncThunk(
  'exhibitorProducts/fetchExhibitorProducts',
  async ({ page = 1, limit = 10, filters = {} }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({ page, limit, ...filters }).toString();
      const response = await axios.get(`/api/get-exhibitors-products?${queryParams}`);
      console.log(response)
      return response.data.data; // Adjust based on API response structure
  
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch exhibitor products');
    }
  }
);

// Thunk for adding a new exhibitor product
export const addExhibitorProduct = createAsyncThunk(
  'exhibitorProducts/addExhibitorProduct',
  async (newProduct, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/create-exproduct', newProduct); // Replace with your actual API endpoint
      return response.data; // Adjust based on your API response
    } catch (error) {
      return rejectWithValue('Failed to add exhibitor product');
    }
  }
);

// Thunk for updating an existing exhibitor product
export const updateExhibitorProduct = createAsyncThunk(
  'exhibitorProducts/updateExhibitorProduct',
  async ({ id, updatedProduct }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/update-exproduct/${id}`, updatedProduct); // Replace with your actual API endpoint
      return response.data; // Adjust based on your API response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update exhibitor product');
    }
  }
);
export const deleteExhibitorProduct = createAsyncThunk(
  'exhibitorProducts/deleteExhibitorProduct',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/api/deleteproduct/${id}`,{withCredentials:true}); // Replace with your actual API endpoint
      return response.data; // Adjust based on your API response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete exhibitor product');
    }
  }
)

const exhibitorProductSlice = createSlice({
  name: 'exhibitorProducts',
  initialState: {
    exhibitorProducts: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
  },
  reducers: {
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExhibitorProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExhibitorProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.exhibitorProducts = action.payload.items;
        state.totalItems = action.payload.totalItems;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(fetchExhibitorProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addExhibitorProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addExhibitorProduct.fulfilled, (state, action) => {
        state.loading = false;
        // Add the new product to the existing array
        state.exhibitorProducts.push(action.payload);
      })
      .addCase(addExhibitorProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateExhibitorProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateExhibitorProduct.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.exhibitorProducts.findIndex(product => product.id === action.payload.id);
        if (index !== -1) {
          // Update the product in the array
          state.exhibitorProducts[index] = action.payload;
        }
      })
      .addCase(updateExhibitorProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteExhibitorProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteExhibitorProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.exhibitorProducts = state.exhibitorProducts.filter(product => product.id !== action.payload.id);
      })
      .addCase(deleteExhibitorProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default exhibitorProductSlice.reducer;
